
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slab } from "@/types/slab";

interface SlabDimensionsFieldsProps {
  formData: Partial<Slab>;
  onDimensionsChange: (dimension: 'length' | 'height', value: number) => void;
  onQuantityChange?: (value: number) => void;
}

export function SlabDimensionsFields({ 
  formData, 
  onDimensionsChange,
  onQuantityChange 
}: SlabDimensionsFieldsProps) {
  return (
    <div className="grid grid-cols-5 gap-4">
      <div className="space-y-2">
        <Label htmlFor="length">Comprimento (pol)</Label>
        <Input
          id="length"
          type="number"
          value={formData.dimensions?.length || ''}
          onChange={(e) => onDimensionsChange('length', Number(e.target.value))}
          min="0"
          className="w-full"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="height">Altura (pol)</Label>
        <Input
          id="height"
          type="number"
          value={formData.dimensions?.height || ''}
          onChange={(e) => onDimensionsChange('height', Number(e.target.value))}
          min="0"
          className="w-full"
        />
      </div>

      <div className="space-y-2">
        <Label>SQFT</Label>
        <Input
          value={formData.sqft}
          readOnly
          disabled
          className="bg-muted w-full"
        />
      </div>

      <div className="space-y-2">
        <Label>Preço/SQFT</Label>
        <Input
          value={formData.pricePerSqft}
          readOnly
          disabled
          className="bg-muted w-full"
        />
      </div>

      <div className="space-y-2">
        <Label>Quantidade</Label>
        <Input
          type="number"
          value={formData.quantity}
          onChange={(e) => onQuantityChange?.(Number(e.target.value))}
          min="0"
          className="w-full"
        />
      </div>
    </div>
  );
}
